import { IAppState } from '../../redux';
import { EPlacingType } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export function selectActivePlacingType(state: IAppState): EPlacingType | null {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { selectedPlacingType },
  } = selectedService;

  return selectedPlacingType;
}
